//External
import React from "react";
import Link from "next/link";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
import { get_cookie } from "utils";

gsap.registerPlugin(ScrollToPlugin);
const is_mobile_app = get_cookie("is_mobile_app");
const mobileMakeSlug = "?screen_type=make_details&title=";
/*******************
  @Purpose :  used for browse by make
  @Parameter : {}
  @Author : INIC
 *******************/
class BrowseByMake extends React.Component {
  constructor(props) {
    super(props);
    this.imgWidth = 361;
    this.imgHeight = 180;
    this.sliderWrapperRef = React.createRef();
    this.sliderInnerRef = React.createRef();
    this.containerRef = React.createRef();
    this.headerContainerRef = React.createRef();
    this.state = {
      timeoffset: 80,
      transformWidth: 0,
      contentWidth: 0,
      itemWidth: 0,
      showLeftButton: true,
      showRightButton: true,
    };
    const r = get_cookie("redirectUrl");
    const dUrl = "/ca/los-angeles";
    if (r) {
      if (r === "/") {
        this.redirectURLValue = dUrl;
      } else {
        this.redirectURLValue = r;
      }
    } else {
      this.redirectURLValue = dUrl;
    }
  }
  /*******************
  @Purpose :  used to left slides
  @Parameter : {}
  @Author : INIC
 *******************/
  left(duration) {
    gsap.to(this.sliderWrapperRef.current, {
      duration,
      scrollTo: {
        x: "-=" + this.state.contentWidth * 3,
      },
    });
  }
  /*******************
  @Purpose :  used to right slides
  @Parameter : {}
  @Author : INIC
 *******************/
  right(duration) {
    gsap.to(this.sliderWrapperRef.current, {
      duration,
      scrollTo: {
        x: "+=" + this.state.contentWidth * 3,
      },
    });
  }
  /*******************
  @Purpose :  used to stop slides
  @Parameter : {}
  @Author : INIC
 *******************/
  stop() {
    gsap.to(this.sliderWrapperRef.current, {
      duration: this.state.timeoffset,
      scrollTo: {
        x: "+=0",
      },
    });
  }

  /*******************
  @Purpose :  used for set up navigation buttons
  @Parameter : {}
  @Author : INIC
 *******************/
  setUpNavButtons() {
    const showLeftButton = this.sliderWrapperRef.current.scrollLeft > 0;
    const showRightButton =
      this.sliderWrapperRef.current.scrollLeft <
      this.sliderInnerRef.current.offsetWidth -
        this.sliderWrapperRef.current.offsetWidth +
        this.state.transformWidth -
        10;

    this.setState({
      ...this.state,
      showLeftButton,
      showRightButton,
    });
  }
  /*******************
  @Purpose :  used for addEventListener
  @Parameter : {}
  @Author : INIC
 *******************/
  componentDidMount() {
    this.updateCalculation();
    window.addEventListener("resize", this.updateCalculation);
  }

  /*******************
  @Purpose :  used for removeEventListener
  @Parameter : {}
  @Author : INIC
 *******************/
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateCalculation);
  }
  /*******************
  @Purpose :  used for updateCalculation
  @Parameter : {}
  @Author : INIC
 *******************/
  componentDidUpdate(prevProps) {
    if (prevProps.brandList !== this.props.brandList) {
      this.updateCalculation();
    }
  }
  /*******************
  @Purpose :  used for update calculation
  @Parameter : {}
  @Author : INIC
 *******************/
  updateCalculation = () => {
    let noOfItemsToDivide = ""; // LG
    const windowWidth = window.outerWidth;
    if (windowWidth <= 761) {
      noOfItemsToDivide = 2.8; // SM
    } else if (windowWidth > 1024 && windowWidth < 1640) {
      noOfItemsToDivide = 5;
    } else if (windowWidth > 761 && windowWidth < 1024) {
      noOfItemsToDivide = 3.5; // MD
    } else {
      noOfItemsToDivide = 5; // LG
    }

    const widthToManage =
      this.headerContainerRef.current.getBoundingClientRect().left + 15;
    const itemWidth =
      this.sliderWrapperRef.current.offsetWidth / noOfItemsToDivide;

    this.setState(
      {
        ...this.state,
        transformWidth:
          (window.innerWidth - this.containerRef.current.offsetWidth) / 2 +
          widthToManage,
        contentWidth: this.sliderWrapperRef.current.offsetWidth,
        itemWidth,
        imgHeight: itemWidth * (this.imgHeight / this.imgWidth),
      },
      () => {
        this.setUpNavButtons();
      }
    );
  };

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  render() {
    return (
      <section className="browse-make py-75 pb-md-0">
        <div
          className="custom-container"
          id="containerLeft1"
          ref={this.headerContainerRef}
        >
          <div className="section-heading mb-0">
            <h3 className="browse-title">Browse by Make</h3>
          </div>
        </div>

        <div
          className="slider-container custom-container"
          ref={this.containerRef}
        >
          <div
            className="slider-wrapper slider-overflow-auto"
            ref={this.sliderWrapperRef}
            onScroll={() => this.setUpNavButtons()}
          >
            <div
              className="slider-inner"
              ref={this.sliderInnerRef}
              style={{
                width:
                  this.state.itemWidth * this.props.brandList?.length + "px",
              }}
            >
              {this.props.brandList &&
                this.props.brandList.map((row, index) => (
                  <div
                    className="slider-boxes"
                    key={index}
                    style={{
                      transform: `translate(${this.state.transformWidth}px,0px)`,
                      width: `${this.state.itemWidth}px`,
                    }}
                  >
                    <div className="slider-boxes-inner brand-logo">
                      <Link
                        href={
                          this.redirectURLValue +
                          "/" +
                          row.slug +
                          (is_mobile_app === "yes"
                            ? mobileMakeSlug + row?.title
                            : "")
                        }
                      >
                        <a>
                          <div
                            className="d-flex align-items-center justify-content-center text-center"
                            style={{ height: `${this.state.imgHeight}px` }}
                          >
                            <picture>
                              <img
                                src={row?.image?.jpeg_w180}
                                className="img-fluid drive-car-dp"
                                alt={row?.alt_tag || row?.title}
                              />
                            </picture>
                          </div>
                          <span className="font-24 text-black brand-name">
                            {row?.title}
                          </span>
                        </a>
                      </Link>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div
            className={
              this.state.showLeftButton
                ? "slider-action-btn action-prev"
                : "d-none"
            }
            onMouseOver={() => this.left(this.state.timeoffset)}
            onMouseUp={() => this.left(this.state.timeoffset)}
            onMouseOut={() => this.stop()}
            onMouseDown={() => this.left(20)}
          >
            <span className="icon icon-chevron-left"></span>
          </div>

          <div
            className={
              this.state.showRightButton
                ? "slider-action-btn action-next"
                : "d-none"
            }
            onMouseOver={() => this.right(this.state.timeoffset)}
            onMouseUp={() => this.right(this.state.timeoffset)}
            onMouseOut={() => this.stop()}
            onMouseDown={() => this.right(20)}
          >
            <span className="icon icon-chevron-right"></span>
          </div>
        </div>
      </section>
    );
  }
}

export default BrowseByMake;
